// extracted by mini-css-extract-plugin
export default {"myPlan":"Myplan_myPlan__vPHkv","edit":"Myplan_edit__foDdQ","table":"Myplan_table__rRL5l","disabled":"Myplan_disabled__XRJYd","inactiveBanner":"Myplan_inactiveBanner__WFf+c"};